import React from "react";
import Vehicle from "components/Tvendo/Distribution/DataMaster/Vehicle/List";

export default function () {
  return <Vehicle />;
}
